import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import * as serviceWorker from './serviceWorker';

import App from './pages/App';
import Firebase, { FirebaseContext } from './firebase';
import { Router } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import history from './history';

// TODO added on 6/2/20 by pkarpovich: move to .env file
const stripePromise = loadStripe('pk_test_WZHd89CzDbBafFTJoen2BeR700J2WtUQDe');
const firebase = new Firebase();

ReactDOM.render(
    <Elements stripe={stripePromise}>
        <FirebaseContext.Provider value={firebase}>
            <Router history={history}>
                <App />
            </Router>
        </FirebaseContext.Provider>
    </Elements>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
